import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ClockLoader } from 'react-spinners';
import { useUserContext } from './context/userContext';
import OwnerLayout from './layouts/owner';
import LoginCallback from './layouts/login-callback';

const AppLoader = () => (
    <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-bg">
        <ClockLoader color="#2F4858" />
    </div>
);

/**
 * Not signed in → straight to Auth0 (there is no landing page; the Flutter app's owner login
 * screen is replaced by the hosted login).
 */
const DefaultRedirect = () => {
    const { isAuthenticated, isLoading, login } = useUserContext();
    const location = useLocation();

    if (isLoading) return <AppLoader />;
    if (isAuthenticated) {
        return <Navigate to={location.pathname.startsWith('/owner') ? location.pathname : '/owner/dashboard'} replace />;
    }
    login();
    return <AppLoader />;
};

export default function App() {
    const { isAuthenticated } = useUserContext();

    return (
        <Routes>
            {isAuthenticated && <Route path="/owner/*" element={<OwnerLayout />} />}
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="*" element={<DefaultRedirect />} />
        </Routes>
    );
}
